import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 5h12","key":"svg-0"}],["path",{"d":"M6 9h12","key":"svg-1"}],["path",{"d":"M12 9v10","key":"svg-2"}]]

const IconCurrencyTenge = createReactComponent('outline', 'currency-tenge', 'CurrencyTenge', __iconNode);

export default IconCurrencyTenge;